import { useHistory } from 'react-router-dom';

import { useAuthenticationDataContext } from '../../Helpers/AuthenticationDataProvider';
import { useAuthorizationDataContext } from '../../Helpers/AuthorizationDataProvider';
import { usePopupContext } from '../../Helpers/PopupProvider';

import useFetchWrapper from '../../Helpers/useFetchWrapper';

const useHeader = () => {

	const {
		email,
		deleteData: deleteAuthenticationData,
		getFullName,
		imageId
	} = useAuthenticationDataContext();
	const {
		role,
		deleteData: deleteAuthorizationData
	} = useAuthorizationDataContext();


	const { sideNavOpen, toggleSideNav } = usePopupContext();
	const { remove } = useFetchWrapper();
	const history = useHistory()

	const onLogout = async () => {
		await remove('/user/authenticate');

		deleteAuthenticationData();
		deleteAuthorizationData();
		navigate('/');
	}

	const navigate = (link: string) => {
		toggleSideNav();
		history.push(link);
	}

	return {
		navigate,
		onLogout,
		state: {
			email,
			fullName: getFullName(),
			imageId,
			role,
			sideNavOpen,
		},
		toggleSideNav
	}
}

export default useHeader;

